import { request } from "utils/request";
import { AxiosPromise } from "axios";

export const authApi = {
  login: (data: any): AxiosPromise<any> =>
    request({
      url: "/v1/admin/auth/login",
      data,
      method: "post",
    }),

  passwordUpdate: (data: any): AxiosPromise<any> =>
    request({
      url: "/v1/admin/auth/password",
      data,
      method: "patch",
    }),

  profile: (): AxiosPromise<any> =>
    request({
      url: "/v1/admin/auth/profile",
    }),
};
